import React, { useState, useEffect } from 'react';
import {
  Card,
  CardBody,
  Button,
  ButtonGroup,
  Form,
  CustomInput,
  FormGroup,
  Input
} from 'reactstrap';
import IntlMessages from '../../../../../helpers/IntlMessages';
import { Separator } from '../../../../../components/common/CustomBootstrap';
import Tooltip from './Tooltip';

let arr = [];
export default function IntegrationInfo({
  integration,
  integrationProperties,
  allProperties,
  saveIntegration,
}) {
  const [formatedProperties, setFormatedProperties] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [list, setList] = useState([]);
  const [name, setName] = useState('');
  const [propertyList, setPropertyList] = useState([]);

  useEffect(() => {
    const result = integrationProperties?.map(id => {
      return allProperties.find(elem => elem.id === id);
    });
    setFormatedProperties(result);
    setList(integrationProperties);
    if (integration.name !== undefined && integration.name !== null) {
      setName(integration.name);
    }
    const property = allProperties?.map((elem) => {
      elem.checked = false;
      result?.forEach((lang) => {
        if (lang?.id === elem?.id) {
          elem.checked = true;
        }
      });
      return elem;
    });
    setPropertyList(property);
  }, [integrationProperties, allProperties]);

  const handleCheckChange = (e) => {
    const updatedList = propertyList.map((elem) =>
      elem.id === e.target.value
        ? { ...elem, checked: !elem.checked }
        : elem
    );

    setPropertyList(updatedList);

    const propertyArr = updatedList
      .filter((elem) => elem.checked)
      .map((elem) => elem.id);

    setList(propertyArr);
  };

  const handleSave = () => {
    saveIntegration({ list, name });
    arr = [];
    setList([]);
    setIsEditing(!isEditing);
  };
  const allSelected =
    propertyList.length > 0 &&
    propertyList.every((p) => p.checked === true);

  const handleSelectAll = (e) => {
    const checked = e.target.checked;

    const updatedList = propertyList.map((elem) => ({
      ...elem,
      checked: checked,
    }));

    setPropertyList(updatedList);

    const propertyArr = checked ? updatedList.map((elem) => elem.id) : [];
    setList(propertyArr);
  };

  const handleNameChange = e => {
    setName(e.target.value);
  };
  const groupName = formatedProperties?.[0]?.groupName != null && formatedProperties?.[0]?.groupName != undefined ? formatedProperties[0].groupName : '';

  const Show = () => {
    return (
      <CardBody>
        <div className="text-center">
          <h6>
            <IntlMessages id='integration.select_properties' />
          </h6>
          <Separator className="mb-3" />
          <h1>{integration ? integration.name : null}</h1>
          <div>
            <h6>Integration</h6>
            <div className="mb-2 container">
              <b>{integration ? integration.name : null} </b>
              <span className="text-muted pl-1">

                ({integration ? integration.id : null})
              </span>
              {integration?.id &&
                <div
                  style={{ cursor: 'pointer', marginLeft: 5, color: 'grey' }}
                  onClick={() => {
                    navigator.clipboard.writeText(integration.id);
                  }}
                >
                  {' '}
                  <i className='iconsminds-file-copy'></i>
                </div>
              }
            </div>
          </div>

          <div>
            <h6>Group</h6>
            <div className="mb-2  container">
              <b> {groupName}  </b>{' '}
              <span className="text-muted pl-1">
                ({integration ? integration.groupId : null})
              </span>
              {integration?.groupId &&
                <div
                  style={{ cursor: 'pointer', marginLeft: 5, color: 'grey' }}
                  onClick={() => {
                    navigator.clipboard.writeText(integration.groupId);
                  }}
                >
                  {' '}
                  <i className='iconsminds-file-copy'></i>
                </div>
              }
            </div>
          </div>
          <div>
            <h6>Properties</h6>
            <div className="mb-2 ">
              {formatedProperties
                ? formatedProperties.map((elem, index) => {
                  return (
                    <div key={index} className="mb-2  container">
                      <b>{elem ? elem?.name : null}</b>{' '}
                      <span className="text-muted pl-1">
                        ({elem ? elem.id : null})
                      </span>
                      {elem?.id &&
                        <div
                          style={{ cursor: 'pointer', marginLeft: 5, color: 'grey' }}
                          onClick={() => {
                            navigator.clipboard.writeText(elem?.id);
                          }}
                        >
                          {' '}
                          <i className='iconsminds-file-copy'></i>
                        </div>
                      }
                    </div>
                  );
                })
                : null}
            </div>
          </div>
          <Button
            size="xs"
            color="success"
            outline
            style={{ marginTop: '20px', display: 'inline-block' }}
            onClick={() => setIsEditing(!isEditing)}
          >
            Edit
          </Button>
        </div>
      </CardBody>
    );
  };

  const Edit = () => {
    return (
      <CardBody>
        <div className="">
          <h6 className="text-center">
            Integration Information{' '}
            <Tooltip
              item={{
                text: '?',
                body:
                  'Integration allows you to select the chat widget appearance, choose properties, and generate code to publish your digital assistant on your website.',
              }}
              id={integration.id}
            />
          </h6>
          <Separator className="mb-3" />
          <div className="text-left" >
            <div className="mb-1 text-left">
              <h6>Integration Name</h6>
              <Input
                className="form-control"
                // style={{
                //   width: '100%',
                //   padding: '14px 20px',
                //   fontSize: '18px',
                //   textAlign: 'center',
                // }}
                name="name"
                defaultValue={integration.name}
                onChange={handleNameChange}
              />
            </div>
            <div>
              <h6>Group</h6>
              <div className="mb-2">
                <span className="text-muted">
                  ({integration ? integration.groupId : null})
                </span>
              </div>
            </div>
            <div>
              <h6>Properties</h6>
              <Form>
                <FormGroup>
                  <div className='integration-property pl-2'>
                    <CustomInput
                      type="checkbox"
                      id="select-all"
                      label="Select All"
                      checked={allSelected}
                      onChange={handleSelectAll}
                    />

                    {propertyList.map((p, index) => {
                      return (
                        <CustomInput
                          key={p.id}
                          type="checkbox"
                          id={index}
                          label={p.name}
                          value={p.id}
                          checked={p.checked}
                          onChange={handleCheckChange}
                        />
                      );
                    })}
                  </div>
                </FormGroup>
              </Form>
            </div>
          </div>
          <Separator className="my-2"></Separator>
          <div className="mb-2 text-center" style={{ marginTop: '20px' }}>
            <Button color="primary" size="xs" onClick={handleSave}>
              Save
            </Button>
            <Button
              size="xs"
              color="secondary"
              className='ml-2'

              onClick={() => setIsEditing(!isEditing)}
            >
              Cancel
            </Button>
          </div>
        </div>
      </CardBody>
    );
  };

  return <Card className="mb-4">{isEditing ? Edit() : Show()}</Card>;
}
